import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[custom-border-error]'
})
export class CustomInputBorderValidationErrorDirective {

  constructor(private el: ElementRef) {
  }

  @HostListener('ngModelChange', ['$event']) ngModelChange(event) {
    this.addFloatingLabel(event);
  }

  addFloatingLabel(event) {
    const fieldValue = this.el?.nativeElement?.innerText;
    if (event) {
      this.el.nativeElement.classList?.remove('custom-input-error');
    } else if (fieldValue && event) {
      this.el.nativeElement.classList?.remove('custom-input-error');
    } else {
      this.el.nativeElement.classList.add('custom-input-error');
    }
  }

}
